import { render, staticRenderFns } from "./ProductCountChart.vue?vue&type=template&id=6a991290&scoped=true"
import script from "./ProductCountChart.vue?vue&type=script&lang=js"
export * from "./ProductCountChart.vue?vue&type=script&lang=js"
import style0 from "./ProductCountChart.vue?vue&type=style&index=0&id=6a991290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a991290",
  null
  
)

export default component.exports